// Shared money formatting for order values.
//
// Extracted because the same formatter had been written out three times, in
// OrderRow, AllOrdersView and DashboardView, and the dashboard's pipeline rows
// would have made a fourth. Four independent definitions of how the shop's money
// is displayed is three too many.

const USD_FORMATTER = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

// A plain amount. Callers that always have a number should use this.
export const formatCurrency = (value) => USD_FORMATTER.format(value);

// An order's value, which may legitimately be absent. Missing and unparseable
// values render as an em dash rather than "$0.00", because a missing price and a
// genuinely free order are different facts and must not look identical.
export const formatOrderValue = (value) => {
  if (value === null || value === undefined || value === '') return '—';
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? USD_FORMATTER.format(numericValue) : '—';
};

// Sum a group of orders in whole cents.
//
// Accumulating in cents rather than dollars is deliberate: repeated floating
// point addition of values like 79.99 drifts, and a daily total that disagrees
// with the rows above it by a cent is the kind of error that costs trust in
// every other number on the screen. Orders without a usable value contribute
// nothing rather than zeroing the total.
export const sumOrderValueCents = (orders) => (orders || []).reduce((total, order) => {
  const raw = order?.total_price;
  if (raw === null || raw === undefined || raw === '') return total;
  const value = Number(raw);
  return Number.isFinite(value) ? total + Math.round(value * 100) : total;
}, 0);
